"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SaraivaTheme = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _CssBaseline = _interopRequireDefault(require("@material-ui/core/CssBaseline"));
var _ScopedCssBaseline = _interopRequireDefault(require("@material-ui/core/ScopedCssBaseline"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _base = require("./base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Componente responsável por implementar o tema da aplicação, deve utilizado na raíz da árvore de componentes da aplicação.
 */
const SaraivaTheme = _ref => {
  let {
    children,
    theme,
    isScopingBaseline
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: (0, _base.getTheme)(theme)
  }, isScopingBaseline ? /*#__PURE__*/_react.default.createElement(_ScopedCssBaseline.default, null, children) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_CssBaseline.default, null), children));
};
exports.SaraivaTheme = SaraivaTheme;
SaraivaTheme.propTypes = {
  children: _propTypes.default.node,
  theme: _propTypes.default.string,
  /**
   * usado para aplicar o baseline somente nos filhos do ThemeProvider
   */
  isScopingBaseline: _propTypes.default.bool
};
SaraivaTheme.defaultProps = {
  children: null,
  theme: _base.THEMES.SARAIVA,
  isScopingBaseline: false
};